import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertSuccess16Icon extends BaseIcon {
  getChildren = () => [
    <path d="M8 0a8 8 0 108 8 8 8 0 00-8-8zm4.27 5.64l-5 6a1 1 0 01-.77.36 1 1 0 01-.78-.45l-2-3a1 1 0 011.66-1.1l1.21 1.88 4.14-5a1 1 0 111.54 1.28z" fill="#56b40a"/>
    ]
  getViewBox = () => '0 0 16 16'
}
